import React from "react";
import { getRegion } from "./clientServices/member";
import store from "./store";
import moment from "moment";
import ms from "ms";

export const getCurrentTimeInMs = () => {
  let timeinms = moment().format('hh[h]:mm[m]:ss[s]').split(':').map(time=>ms(time)).reduce((a,b)=>a+b,0)
  return timeinms
}

export const moneyFormat = (input, format = " đ") => {
  let result = inputFormatToInt(input.toString())
    .toString()
    .replace(/\D/g, "")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return inputFormatToInt(result) ? result + format : "0đ";
};

export const inputFormat = (input, format = ",000 đ") => {
  if (!input || typeof input !== "string") return "";
  if (input.includes(format)) {
    input = input.replace(format, "");
  } else if (input.includes(format.slice(0, -1))) {
    input = input.slice(0, -format.length);
  }

  let result = inputFormatToInt(input)
    .toString()
    .replace(/\D/g, "")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return inputFormatToInt(result) ? result + format : "0đ";
};
export const inputFormatMoney = (input, format = "0,000 đ") => {
  if (!input || typeof input !== "string") return "";
  if (input.includes(format)) {
    input = input.replace(format, "");
  } else if (input.includes(format.slice(0, -1))) {
    input = input.slice(0, -format.length);
  }

  let result = inputFormatToInt(input)
    .toString()
    .replace(/\D/g, "")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return inputFormatToInt(result) ? result + format : "";
};
export const inputFormatPoint = (input, format = " điểm") => {
  if (!input || typeof input !== "string") return "";
  if (input.includes(format)) {
    input = input.replace(format, "");
  } else if (input.includes(format.slice(0, -1))) {
    input = input.slice(0, -format.length);
  }

  let result = inputFormatToInt(input)
    .toString()
    .replace(/\D/g, "")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return inputFormatToInt(result) ? result + format : "";
};

export const inputCustomFormat = (input, format = " đ") => {
  if (input.includes(format)) {
    input = input.replace(format, "");
  } else if (input.includes(format.slice(0, -1))) {
    input = input.slice(0, -format.length);
  }
  let inputNumReplace = input
    .replace(/\D/g, "")
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return inputNumReplace ? inputNumReplace + format : inputNumReplace;
};

export const inputFormatToInt = input => {
  input = input ? input.replace(/[^0-9]/g, "") : 0;
  return parseInt(input);
};

export const setMyRegion = (value, cb) => {
  getRegion({
    level: 2,
    location: {
      lat: value.geometry.lat,
      lng: value.geometry.long
    }
  }).then(res => {
    localStorage &&
      localStorage.setItem(
        "my-region",
        btoa(
          unescape(encodeURIComponent(JSON.stringify(_.get(res, "data", ""))))
        )
      );
    typeof cb === "function" && cb();
  });
};

export const setMyLocation = value => {
  localStorage &&
    localStorage.setItem(
      "my-location",
      btoa(unescape(encodeURIComponent(JSON.stringify(value))))
    );
  try {
    if (value) {
      setMyRegion(value);
      value = JSON.parse(decodeURIComponent(escape(atob(value))));
    }
  } catch (e) {
    console.log(e);
  } finally {
    return value;
  }
};

export const getMyLocation = () => {
  let value = localStorage && localStorage.getItem("my-location");
  try {
    if (value) {
      value = JSON.parse(decodeURIComponent(escape(atob(value))));
    }
  } catch (e) {
    console.log(e);
  } finally {
    return value;
  }
};

export const getDefaultOriginPlace = () => {
  let value = localStorage && localStorage.getItem("my-location");
  try {
    if (value) {
      value = JSON.parse(decodeURIComponent(escape(atob(value))));
    }
  } catch (e) {
    console.log(e);
  } finally {
    return value;
  }
};

export const setDefaultOriginPlace = (value, cb) => {
  localStorage &&
    localStorage.setItem(
      "my-location",
      btoa(unescape(encodeURIComponent(JSON.stringify(value))))
    );
  setMyRegion(value, cb);
};

export const getDefaultPhone = () => {
  let value = localStorage && localStorage.getItem("default-phone");
  try {
    if (value) {
      value = JSON.parse(decodeURIComponent(escape(atob(value))));
    }
  } catch (e) {
  } finally {
    return value;
  }
};

export const getMyPhone = () => {
  let value = localStorage && localStorage.getItem("phone");
  try {
    if (value) {
      value = JSON.parse(decodeURIComponent(escape(atob(value))));
    }
  } catch (e) {
    console.log(e);
  } finally {
    return value;
  }
};

export const setDefaultPhone = value => {
  localStorage &&
    localStorage.setItem(
      "default-phone",
      btoa(unescape(encodeURIComponent(JSON.stringify(value))))
    );
};

export const getMyRegion = () => {
  let value =
    typeof localStorage !== "undefined" && localStorage.getItem("my-region");
  try {
    if (value) {
      value = JSON.parse(decodeURIComponent(escape(atob(value))));
    }
  } catch (e) {
  } finally {
    return value;
  }
};

const deg2rad = deg => {
  return deg * (Math.PI / 180);
};

export const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
  var R = 6371.008; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return parseFloat(d.toFixed(1));
};
export const calculateWeightFee = (weight, config) => {
  let weightFee = 0;
  const step = config.priceConfig;
  for (let i = 0; i < step.length; i++) {
    if (weight >= step[i].from && weight <= step[i].to) {
      weightFee = step[i].value;
      break;
    }
  }
  return weightFee;
};

export const getOriginDestinationObj = (startAddr, endAddrs) => {
  const obj = {
    originPlace: null,
    destinationPlaces: [],
    originName: "",
    destinationNames: []
  };
  if (startAddr && startAddr.geometry) {
    obj.originPlace = {
      lat: startAddr.geometry.lat,
      lng: startAddr.geometry.long
    };
    obj.originName = startAddr.address;
  }

  if (endAddrs && !endAddrs.map(addr => addr.geometry).includes(undefined)) {
    endAddrs.forEach(endAddr => {
      obj.destinationPlaces.push({
        lat: endAddr.geometry.lat,
        lng: endAddr.geometry.long
      });
      obj.destinationNames.push(endAddr.address);
    });
  }
  return obj;
};

export const getOS = () => {
  const { userAgent } = window.navigator;
  const { platform } = window.navigator;
  const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
  const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
  const iosPlatforms = ["iPhone", "iPad", "iPod"];
  let os = null;
  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "Mac OS";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "iOS";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "Windows";
  } else if (/Android/.test(userAgent)) {
    os = "Android";
  } else if (!os && /Linux/.test(platform)) {
    os = "Linux";
  }
  localStorage && localStorage.setItem("platform", os);
  return os;
};

export const getImagePaymentType = type => {
  let imagePaymentType = " ";
  if (type == "momo") {
    imagePaymentType = "images/momo.png";
  } else if (type == "zalo") {
    imagePaymentType = "images/zalopay.png";
  } else if (type == "bank") {
    imagePaymentType = "images/bank.png";
  } else {
    imagePaymentType = "images/directCharge.png";
  }
  return imagePaymentType;
};
export const inputFomatAlias = input => {
  var str = input;
  str = str.toLowerCase();
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(
    /!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'| |\"|\&|\#|\[|\]|~|$|_|-/g,
    ""
  ); /* tìm và thay thế các kí tự đặc biệt trong chuỗi sang kí tự "" */
  // str= str.replace(/-+-/g,"-"); //thay thế 2- thành 1-
  // str= str.replace(/^\-+|\-+$/g,""); //cắt bỏ ký tự - ở đầu và cuối chuỗi

  return str;
};
export const billPlease = cart => {
  let sum = 0;
  let sums = 0;
  for (var i = 0; i < cart.length; i++) {
    if (cart[i].toppingSelected && cart[i].toppingSelected.length) {
      sum = billTopping(cart[i]);
    } else {
      sum = cart[i].pricePromote * cart[i].quantity;
    }
    sums = sums + sum;
  }
  return sums;
};

const billTopping = dataDetail => {
  let sum = dataDetail.pricePromote;
  dataDetail.toppingSelected.map((item, i) => {
    item.toppingSelected.map((t, j) => {
      sum += t.price * t.quantity;
    });
  });
  return sum * dataDetail.quantity;
};

export const countDishes = data => {
  let count = 0;
  for (var i = 0; i < data.length; i++) {
    count = count + data[i].quantity;
  }
  return count;
};

export const calculateCODFee = (deposit, orderType, config) => {
  let CODFee = 0;
  const configCOD = config && config[orderType];
  if (!configCOD) {
    return CODFee;
  }
  if (configCOD.strategy === "fixed") {
    const step = configCOD.step;
    for (let i = 0; i < step.length; i++) {
      if (deposit >= step[i].from && deposit <= step[i].to) {
        CODFee = step[i].value;
        break;
      }
    }
  } else if (configCOD.strategy === "percent") {
    const step = configCOD.step;
    for (let i = 0; i < step.length; i++) {
      if (deposit >= step[i].from && deposit <= step[i].to) {
        CODFee = deposit * step[i].value;
        CODFee = Math.round(CODFee / 1000) * 1000;
        break;
      }
    }
  }
  return CODFee;
};

export const convetType = item => {
  if (item.type === 0) {
    return "Tạo đơn";
  } else if (item.type === 1) {
    return "Xác nhận đơn";
  } else if (item.type === 2) {
    if (item.member === item.customer) {
      return "Khách hàng huỷ đơn";
    } else if (item.member === item.merchant) {
      return "Cửa hàng huỷ đơn";
    } else {
      return " Huỷ";
    }
  } else if (item.type === 3) {
    return "Chỉnh sửa";
  } else if (item.type === 4) {
    return "Đã nhận hàng";
  } else if (item.type === 5) {
    return "Hoàn Thành";
  } else if (item.type === 7) {
    return "Tài xế nhận đơn";
  } else {
    return "Huỷ";
  }
};
export const msToTime = duration => {
  var minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;

  return hours + ":" + minutes;
};

export const StatusTrans = (status, deliveryType) => {
  switch (status) {
    case 0:
      return (
        <span style={{ color: "#ff7f50" }}>
          <i className="icon-icon-note-1"/> Chờ xác nhận
        </span>
      );
      break;
    case 1:
      return (
        <span style={{ color: "#ff7f50" }}>
          <i className="icon-edit"/> Chờ chỉnh sửa
        </span>
      );
      break;
    case 2:
      return (
        <span style={{ color: "#1589D8" }}>
          <i className="icon-clock"/> Chuẩn bị hàng
        </span>
      );
      break;
    case 3:
      return (
        <span style={{ color: "#FFAC0A" }}>
          <i className="icon-timer"/> {
            deliveryType === "heyu" ?
            "Tài xế đang giao" :
            deliveryType === "selfDelivery" ?
            "Cửa hàng giao hàng" :
            "Đang giao hàng"
          }
        </span>
      );
      break;
    case 4:
      return (
        <span style={{ color: "#04B18D" }}>
          <i className="icon-verify"/> Hoàn thành
        </span>
      );
      break;
    case 5:
      return (
        <span style={{ color: "#E93940" }}>
          <i className="icon-information"/> Hủy
        </span>
      );
      break;
      return <span></span>;
  }
};

export const StatusTransNoColor = (status, deliveryType) => {
  switch (status) {
    case 0:
      return (
        <span
          style={{ color: "#161616", fontSize: "16px", paddingLeft: "12px" }}
        >
          {" "}
          Chờ xác nhận
        </span>
      );
      break;
    case 1:
      return (
        <span
          style={{ color: "#161616", fontSize: "16px", paddingLeft: "12px" }}
        >
          {" "}
          Chờ chỉnh sửa
        </span>
      );
      break;
    case 2:
      return (
        <span
          style={{ color: "#161616", fontSize: "16px", paddingLeft: "12px" }}
        >
          {" "}
          Chuẩn bị hàng
        </span>
      );
      break;
    case 3:
      return (
        <span
          style={{ color: "#161616", fontSize: "16px", paddingLeft: "12px" }}
        >
          {" "}
          {deliveryType === "heyu"
            ? "Tài xế đang giao"
            : deliveryType === "selfDelivery"
            ? "Cửa hàng giao hàng"
            : "Đang giao hàng"}
        </span>
      );
      break;
    case 4:
      return (
        <span
          style={{ color: "#161616", fontSize: "16px", paddingLeft: "12px" }}
        >
          {" "}
          Hoàn thành
        </span>
      );
      break;
    case 5:
      return (
        <span style={{ color: "#161616", paddingLeft: "12px" }}> Huỷ</span>
      );
      break;
      return <span></span>;
  }
};


function toRadians(degrees) {
  return degrees * Math.PI / 180;
};

// Converts from radians to degrees.
function toDegrees(radians) {
  return radians * 180 / Math.PI;
}


export const calculateBearing = (startLat, startLng, destLat, destLng) => {
  startLat = toRadians(startLat);
  startLng = toRadians(startLng);
  destLat = toRadians(destLat);
  destLng = toRadians(destLng);

  let y = Math.sin(destLng - startLng) * Math.cos(destLat);
  let x = Math.cos(startLat) * Math.sin(destLat) -
        Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng);
  let brng = Math.atan2(y, x);
  brng = toDegrees(brng);
  return (brng + 360) % 360; //(brng + 180) % 360;
}
